<template>
  <div class="purchase">
    <div class="purchase-head">
        <div>
            <span class="purchase-title">{{ type === 's' ? supplyObj.title : demandObj.demandTitle }}</span>
            <span style="display: block; color: #888888;margin-top: 10px;">更新时间：{{ type === 's' ? supplyObj.modifiedTime : demandObj.updateTime }}</span>
        </div>
        <div>
            <span>
                <a-icon type="eye"/>
                浏览量：
                <span style="color: #FF8C00;">{{ type === 's' ? supplyObj.visit : demandObj.views }}</span>
            </span>
            <span style="margin:0 50px 0 40px;">
                <a-icon v-if="!collectFlag && type === 's'" :theme="supplyObj.isFavorite === '1' ? 'filled' : 'outlined'" :style="{ color: supplyObj.isFavorite === '1' ? '#FF8500' : '' }" type="star" @click="shoucang"/>
                <a-icon v-if="!collectFlag && type === 'd'" :theme="demandObj.isFavorites ? 'filled' : 'outlined'" :style="{ color: demandObj.isFavorites ? '#FF8500' : '' }" type="star" @click="shoucang"/>
                <a-icon v-if="collectFlag" :theme="collectStatus ? 'filled' : 'outlined'" :style="{ color: collectStatus ? '#FF8500' : '' }" type="star" @click="shoucang"/>
                收藏
            </span>
        </div>
    </div>
    <div class="purchase-body">
        <img v-if="type === 's'" :src="supplyObj.picture | ossComplete"/>
        <div :class="type === 's' ? 'purchase-info-s' : 'purchase-info-d'">
            <div class="flex-box" style="margin-top: 10px;" >
                <span class="purchase-item-left">价格</span>
                <span class="purchase-item-right price" v-if="type === 's'">{{  supplyObj.price ? `${parseFloat(supplyObj.price).toFixed(2)}元` : '当面议价'}}</span>
                <span class="purchase-item-right price" v-if="type === 'd'">{{  demandObj.price ? `${parseFloat(demandObj.price).toFixed(2)}元` : '当面议价'}}</span> 
            </div>
            <div class="flex-box" style="margin-top: 10px;">
                <span class="purchase-item-left">{{ type === 's' ? '品类' : '询单品类' }}</span>
                <span class="purchase-item-right" style="color: #333333;">{{ type === 's' ? supplyObj.categoryName : demandObj.demandCategory }}</span>
            </div>
            <div class="flex-box">
                <span class="purchase-item-left">{{ type === 's' ? '品种' : '询单品种' }}</span>
                <span class="purchase-item-right" style="color: #333333;">{{ type === 's' ? supplyObj.varietyName : demandObj.demandVarieties }}</span>
            </div>
            <div class="flex-box" v-if="type === 'd'">
                <span class="purchase-item-left">需求时间</span>
                <span class="purchase-item-right" style="color: #333333;">{{ demandObj.releaseTime }}</span>
            </div>
            <div class="flex-box" v-if="type === 's'">
                <span class="purchase-item-left">产地</span>
                <span class="purchase-item-right" style="color: #333333;">{{ `${supplyObj.originProvinceName}${supplyObj.originCityName}${supplyObj.originAreaName}` }}</span>
            </div>
            <div class="flex-box">
                <span class="purchase-item-left">{{ type === 's' ? '库存地' : '收货地' }}</span>
                <span class="purchase-item-right" style="color: #333333;">{{ type === 's' ? `${supplyObj.stockProvinceName}${supplyObj.stockCityName}${supplyObj.stockAreaName}`: demandObj.shippingAddress }}</span>
            </div>
            <a-button v-if="type === 's'" style="width: 125px;height: 39px;font-size: 14px;float: right;margin-right: 29px;" type="primary" @click="placeAnOrder">
                <img :src="orderIcon" style="width: 14px;height: 14px;"/>
                <span style="margin-left: 3px;">我要下单</span>
            </a-button>
        </div>
    </div>
    <a-modal v-model="tipVisible" :width="450" style="text-align:center;" :footer="null">
      <div v-if="!this.isLogin"><span style="color: red;">注意：</span>请先进行<a href="/login">登录</a></div>
      <div v-if="this.isLogin && this.certificateStatus === '0'"><span style="color: red;">注意：</span>尚未认证，请先进行<a href="/personalCenter/authentication">认证</a></div>
    </a-modal>
    <a-modal v-model="visible" title="确认订单信息" on-ok="handleOk">
        <template slot="footer">
          <a-button key="back" @click="handleCancel">
            取消
          </a-button>
          <a-button key="submit" :loading="loading" @click="handleOk">
            确认
          </a-button> 
        </template>
        <a-form-model
            v-bind="formModalLayout"
            ref="ruleForm"
            :model="ruleForm"
            :rules="rules"
            :labelCol="{ span: 6, offset: 0 }"
            labelAlign="right"
        >
            <a-form-model-item label="需求订单">
            <img style="width: 100px;height: 80px;" :src="supplyObj.picture | ossComplete">
            <div style="display: inline-block;line-height: normal;margin-left: 10px;">
                <div>{{ supplyObj.title }}</div>
            </div>
            </a-form-model-item>
            <a-form-model-item label="联系人" prop="contacts">
                <a-input placeholder="请输入联系人" v-model="ruleForm.contacts"/>
            </a-form-model-item>
            <a-form-model-item label="联系方式" prop="phone">
            <a-input placeholder="请输入联系方式" v-model="ruleForm.phone"/>
            </a-form-model-item>
            <a-form-model-item label="给卖家留言" prop="message">
            <a-textarea style="margin-top: 4px;" placeholder="请输入留言内容" v-model="ruleForm.message" :rows="4" allow-clear />
            </a-form-model-item>
        </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
name: "Purchase",
components: {
},
data () {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入联系方式'));
      } else if (!this.$utils.test.mobile(value)) {
        callback(new Error('联系方式格式错误'));
      } else {
        callback();
      }
    }
return {
    proImg: require('@/assets/img/pear.jpg'),
	orderIcon: require('@/assets/img/getOrder.png'),
    visible: false, // 弹框
    tipVisible: false, // 登录提示框
    formModalLayout: {
        labelCol: {
            span: 6
        },
        wrapperCol: {
            span: 16
        },
    },
    ruleForm: {
        contacts: "", //  联系人
        phone: "", // 联系方式
        message: "" //买家留言
    },
    rules: {
        contacts: [
            { required: true, message: '请输入联系人', trigger: 'blur' },
        ],
        phone: [
            { required: true, message: '请输入联系方式', trigger: 'blur' },
            { validator: validatePhone, trigger: 'blur' }
        ]
    },
    loading: false,
    collectFlag: false, // 收藏操作flag
    collectStatus: false, // 收藏状态
    certificateStatus: '', // 0:未认证 1:个人认证 2:企业认证
    img64:'data:image/png;base64,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',
}
},
props: {
    type: {
        type: String,
        default: 's'
    },
    supplyObj: {
        type: Object,
        default: () => ({
            auditStatus: "",
            categoryId: "",
            categoryName: "", // 品类名称
            collection: "", // 浏览量
            companyContacts: "",
            companyName: "",
            companyPhone: "",
            contacts: "",
            createdTime: "",
            creatorId: "",
            detail: "", // 售卖详情
            phone: "",
            picture: "",
            title: "",
            varietyId: "",
            varietyName: "", // 品种名称
            id: "",
            isActive: 1,
            isFavorite: '', // 0：否 1：是
            modifiedTime: "",
            modifierId: "",
            originProvinceCode: "", // 产地省code
            originProvinceName: "", // 产地省name
            originCityCode: "", // 产地市code
            originCityName: "", // 产地市name
            originAreaCode: "", // 产地区code
            originAreaName: "", // 产地区name
            stockProvinceName: "", // 库存省name
            stockProvinceCode: "", // 库存省code
            stockCityCode: "", // 库存地市code
            stockCityName: "", // 库存城市name
            stockAreaCode: "", // 库存地市code
            stockAreaName: "", // 库存地市name
            price: ''
        })
    },
    demandObj: {
        type: Object,
        default: () => ({
            contactName: '', // 联系人
            contactTel: '', // 联系人电话
            createTime: '', // 创建时间
            demandCategory: '', //品类
            demandTail: "", //需求详情
            demandTitle: "", //主题
            count: '',
            time: '',
            demandVarieties: "", //品种
            id: "",
            isFavorites: "", //是否收藏 true, fales
            releaseTime: "", //发布时间
            releaseUserId: "", //发布人
            releaseUserName: "", //发布人名称
            shelvesStatus: "", //状态
            shippingAddress: "", //发布地址
            views: "", //访问量
            province: '',
            city: "", // 产地市name
            price: ''
        })
    }
},
watch: {

},
methods: {
    async shoucang() {
        if (!this.isLogin) {
            this.tipVisible = true
            return;
        }
        const status = await this.getCertificationStatus()
        if (this.isLogin && status === '0') {
            this.tipVisible = true
            return;
        }
        if (this.collectFlag) {
            this.collectStatus ? this.unCollect() : this.collect()
            return
        } 
        if ((this.type === 's' && this.supplyObj.isFavorite === '0') || (this.type === 'd' && !this.demandObj.isFavorites)) {
            this.collect()
        } 
        if ((this.type === 's' && this.supplyObj.isFavorite === '1') || (this.type === 'd' && this.demandObj.isFavorites)) {
            this.unCollect()
        } 
    },
    // 收藏
    collect() {
        const params = {
            body: {
                dataId: this.type === 's' ? this.supplyObj.id : this.demandObj.id,              //收藏数据id
                createTime: "",    //收藏时间
                createId: this.userInfo.id,    //收藏人id
                dataCategory: this.type === 's' ? this.supplyObj.categoryName : this.demandObj.demandCategory,    //品种
                dataType: this.type === 'd' ? 1 : 2,    //数据类型，1：需求  2：供应
                dataUserName: this.type === 's' ? this.supplyObj.companyName : this.demandObj.releaseUserName, //联系人名称
                dataUserTel: this.type === 's' ? this.supplyObj.companyPhone : this.demandObj.contactTel,   //联系人电话
                dataVarieties: this.type === 's' ? this.supplyObj.varietyName : this.demandObj.demandVarieties,   //品类
                dataTitle: this.type === 's' ? this.supplyObj.title : this.demandObj.demandTitle,   //主题    
                createName: ""    //收藏人名称
            }
        }
        this.$axios.demandAddCollect(params).then(res => {
            this.collectFlag = true
            console.log('demandAddCollect', res);
            if (res.data.code === '0') {
                this.$message.success('收藏成功！')
                this.collectStatus = true
            } else {
                this.$message.success(res.data.msg)
            }
        })
    },
    // 取消收藏
    unCollect() {
        const params = {
            body :{
                createId: this.userInfo.id, //当前登录用户
                dataType: this.type === 'd' ? 1 : 2, //数据类型，1：需求，2：供应
                dataId: this.type === 's' ? this.supplyObj.id : this.demandObj.id //当前数据id
            }
        }
        this.$axios.demandUnCollect(params).then(res => {
            this.collectFlag = true
            if (res.data.code === '0') {
                this.$message.success('取消成功！')
                this.collectStatus = false
            } else {
                this.$message.success(res.data.msg)
            }
        })
    },
    // 我要下单
    async placeAnOrder() {
        if (!this.isLogin) {
            this.tipVisible = true
            return;
        }
        const status = await this.getCertificationStatus()
        if (this.isLogin && status === '0') {
            this.tipVisible = true
            return;
        }
        this.ruleForm.contacts = this.userInfo.userName
        this.ruleForm.phone = this.userInfo.phone
        this.visible = true
    },
    // 查询认证状态
    async getCertificationStatus() {
      const { data: { code, msg, body: { certificateStatus } } } = await this.$axios.getCertification({})
      if (code != 0) return this.$message.error(msg)
      this.certificateStatus = certificateStatus
      return certificateStatus
    },
    handleOk() {
        this.$refs.ruleForm.validate(valid => {
            if (valid) {
            this.addOrder()
            } else {
            this.$message.warning('请填写必填项！')
            return false
            }
      })
    },
    handleCancel() {
        this.visible = false
    },
    addOrder() {
        const params = {
            body:{
                supplyId: this.supplyObj.id, // 供应id
                contacts: this.ruleForm.contacts, //  联系人
                phone: this.ruleForm.phone, // 联系方式
                message: this.ruleForm.message //买家留言
            }
        }
        this.$axios.placeAnOrder(params).then(res => {
            console.log('placeAnOrder', res);
            if (res.data.code === '0') {
                this.$message.success('下单成功！')
                this.visible = false
            } else {
                this.$message.error(res.data.msg)
            }
        })
    }
},
computed: {
    ...mapGetters(['userInfo']),
    ...mapGetters(['isLogin']),
},
created () {

},
mounted () {

},
destroyed () {

},
}
</script>

<style scoped lang="less">
.purchase {
    .purchase-head {
        margin-top: 22px;
        display: flex;
        width: 100%;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        i {
            font-size: 16px;
            margin-right: 8px;
        }

        .purchase-title {
            font-size: 18px;
            font-weight: 600;
            color: #333333;
            line-height: 24px;
        }
        
    }
    .purchase-body {
        margin-top: 15px;
        position: relative;
        img {
            width: 296px;
            height: 197px;
        }
        .purchase-info-s {
            position: absolute;
            left: 296px;
            right: 0;
            top: 0;
            bottom: 0;
            height: 100%;
            display: inline-block;
            vertical-align: top;
            div {
                margin-bottom: 20px;
                margin-left: 70px;
            }
        }

        .purchase-info-d {
            div {
                margin-bottom: 20px;
            }
        }
        .flex-box{
            display: flex;
            align-items: center;
        }
        .purchase-item-left{
            display: flex;
            flex:1;
            min-width: 100px;
            color: #888888;
        }
        .purchase-item-right{
            flex: 7;
            color: #333333;
        }
        .price {
            font-size: 21px;
            font-weight: 600;
            color: #FF5001;
            line-height: 29px;
        }
    }

    .table_img {
        width: 100px;
        height: 80px;
    }
}
</style>
